<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      content-class="overflow-hidden"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>PAY <br v-if="$vuetify.breakpoint.name == 'xs'"> ({{ getSelectedDevice?.name }}, ID:{{ getSelectedDevice?.id }})</span>
          <div>
            <v-btn 
              :disabled="loading"
              outlined
              @click="hidePay"
              class="text-right text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
              :x-large="$vuetify.breakpoint.name == 'xl'"
              :large="$vuetify.breakpoint.name == 'lg'"
            >
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-col class="col-12 mt-3">
                <v-row>
                  <v-col class="col-12">
                    <v-row class="d-flex justify-space-between">
                      <v-col class="col-3"></v-col>
                      <v-col class="col-6 mt-12">
                        <v-text-field
                          class="mt-2"
                          :disabled="loading"
                          v-model="PayDTO.CardNumber"
                          label="Card Number"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-3"></v-col>
                      <v-col class="col-3"></v-col>
                      <v-col class="col-4">
                        <v-text-field
                          class="mt-2"
                          :disabled="loading"
                          v-model="PayDTO.Date"
                          label="Date"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-2">
                        <v-text-field
                          class="mt-2"
                          :disabled="loading"
                          v-model="PayDTO.CVV"
                          label="CVV"
                          outlined
                          dense
                          hide-details
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-3"></v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <v-col class="col-12 d-flex justify-end mt-12">
              <v-btn :disabled="loading" depressed outlined large v-show="false">
                SAVE PAYMENT DETAILS
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import { HubConnectionBuilder, LogLevel, HttpTransportType } from '@microsoft/signalr'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  const config = process.env.VUE_APP_ui_api_url
  export default {
    props: ['isShowDialog'],
    name: 'Pay',
    data(){
      return {
        selectedDevice: null,
        loading: false,
        PayDTO:{
          CardNumber: null,
          Date: null,
          CVV: null
        }
      }
    },
    components:{
    },
    computed:{
      ...mapGetters(['getAccessToken', 'getSelectedDevice']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    async mounted(){
      this.$root.$on('showPay', async (dv) => {
        this.selectedDevice = dv
        console.log(this.selectedDevice)
        
        //await this.tryConnectToHub()
      })
    },
    methods:{
      ...mapActions([]),
      hidePay(){
        this.$emit('hidePay')
      },
    },
    beforeDestroy(){
      //if(this.connectionControl) this.connectionControl.stop()
    }
  }
</script>